import { parseCookies } from 'nookies'

import { api } from '@/services/axios'

export interface ICreateTituloPremiado {
  titulo: string
  premio: string
  campanha_id: number
  usuario_id: string
}

export interface ITituloPremiado extends ICreateTituloPremiado {
  id: number
  Status: string
  usuario_Ganhador_Id?: number
}

export async function createTituloPremiado(data: ICreateTituloPremiado) {
  const { 'reactAuth.id': userId } = parseCookies()
  const dataWithUserId = { ...data, usuario_id: userId }

  const response = await api.post(
    'CampanhaTituloPremiado/Create',
    dataWithUserId,
  )
  return response.data
}

export async function getTituloPremiadoById(id: number) {
  const response = await api.get(`CampanhaTituloPremiado/GetById/${id}`)
  return response.data
}

export async function deleteTituloPremiado(id: number) {
  const response = await api.delete(`CampanhaTituloPremiado/Delete/${id}`)
  return response.data
}

export async function updateTituloPremiado(
  id: number,
  data: ICreateTituloPremiado,
) {
  const { 'reactAuth.id': userId } = parseCookies()
  const dataWithUserId = { ...data, usuario_id: userId }

  const response = await api.put(
    `CampanhaTituloPremiado/Update/${id}`,
    dataWithUserId,
  )
  return response.data
}

export async function getAllTitulosPremiados(campanhaId: number) {
  const response = await api.get(`CampanhaTituloPremiado/GetAll`, {
    params: { campanhaId },
  })
  return response.data
}

interface AtualizarStatusTituloPremiadoDto {
  usuarioGanhadorId: number
  status: string
}

export async function finalizarTituloPremiado(
  tituloId: number,
  usuarioGanhadorId: number,
) {
  const payload: AtualizarStatusTituloPremiadoDto = {
    usuarioGanhadorId,
    status: 'Finalizado',
  }

  try {
    await api.put(
      `CampanhaTituloPremiado/FinalizarTitulo/${tituloId}`,
      payload,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    )
    return true
  } catch (error) {
    console.error(`Erro ao finalizar título premiado ${tituloId}:`, error)
    return false
  }
}
